import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Container, IconButton, useMediaQuery, useTheme } from '@mui/material';
import { useMemo, useState } from 'react';

import CarMaxLogo from '../../CarMaxLogo';
import styles from './Header.module.scss';
import NavDrawer from './Mobile/NavDrawer';
import Navbar from './Navbar';
import SearchBar from './SearchBar';

interface HeaderProps {
    /**
     * Adds SearchBar in component
     * Requires AuthProvider as parent component.
     */
    includeSearchBar?: boolean;
}
const Header = ({ includeSearchBar = false }: HeaderProps) => {
    const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
    const theme = useTheme();

    const isLargerScreen = useMediaQuery(theme.breakpoints.up('lg'));
    const isMobileScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const isSmallerScreen = useMediaQuery('(max-width: 449px)');

    const openDrawer = () => setDrawerOpen(true);
    const closeDrawer = () => setDrawerOpen(false);

    const logoType = useMemo(() => {
        if (isSmallerScreen) {
            return 'small-icon-only';
        } else if (isMobileScreen) {
            return 'small';
        } else {
            return 'large';
        }
    }, [isSmallerScreen, isMobileScreen]);

    return (
        <AppBar
            position="static"
            data-testid="header"
            className={styles['app-bar']}
            color="secondary"
            sx={{ paddingBottom: includeSearchBar ? '12px' : '0px', backgroundColor: '#00264F' }}>
            <Container>
                <nav className={styles['header-nav']}>
                    {!isLargerScreen && (
                        <IconButton
                            className={styles['icon-button']}
                            onClick={openDrawer}
                            size="medium"
                            aria-label="open side drawer"
                            sx={{ color: '#fff' }}>
                            <MenuIcon fontSize="large"></MenuIcon>
                        </IconButton>
                    )}
                    <CarMaxLogo logoType={logoType} className={styles['logo']} />
                    <NavDrawer isOpen={drawerOpen} onClose={closeDrawer}></NavDrawer>
                    <Navbar />
                </nav>
                {includeSearchBar && <SearchBar />}
            </Container>
        </AppBar>
    );
};

export default Header;
